var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomsItemValue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89991 8.45C7.76491 8.155 7.39991 7.85 7.39991 7.375C7.39991 6.83 7.90491 6.45 8.74991 6.45C9.63991 6.45 9.96991 6.875 9.99991 7.5H11.1049C11.0699 6.64 10.5449 5.85 9.49991 5.595V4.5H7.99991V5.58C7.02991 5.79 6.24991 6.42 6.24991 7.385C6.24991 8.54 7.20491 9.115 8.59991 9.45C9.84991 9.75 10.0999 10.19 10.0999 10.655C10.0999 11 9.85491 11.55 8.74991 11.55C7.71991 11.55 7.31491 11.09 7.25991 10.5H6.15991C6.21991 11.595 7.03991 12.21 7.99991 12.415V13.5H9.49991V12.425C10.4749 12.24 11.2499 11.675 11.2499 10.65C11.2499 9.23 10.0349 8.745 8.89991 8.45Z",
    fill: "#828282"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.3,
    stroke: "#828282",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomsItemValue);
export default __webpack_public_path__ + "static/media/customs-item-value.a1f16434.svg";
export { ForwardRef as ReactComponent };